import AbstractApiModel from '@/models/abstracts/AbstractApiModel';
import doc from '@model-core/decorators/doc';

/** Type d'un export (enum App\\Entity\\ExportType de l'API, GET /export_types) : CSV sans détails, CSV avec détails, ZIP des PDF */
export default class ExportTypeModel extends AbstractApiModel {
  protected _path = '/export_types/{?id}';

  @doc.string declare reference: string;
  @doc.string declare label: string;

  /** URN à envoyer à l'API pour écrire la relation (corps d'un POST / PATCH) ; un filtre prend l'id */
  get urn(): string {
    return this.get<string, string>('@urn', `$:teiji:export_type:${this.id}`);
  }
}
